export enum CustomQuestionPropertyUnderValidation {
	questionText = 'QuestionText',
	responseOptions = 'ResponseOptions',
	responseOptionGroupName = 'ResponseOptionGroupName',
	attributeName = 'AttributeName',
	hierarchy = 'Hierarchy',
}
